import React from 'react';
import dynamicfunction from '../../utils/dynamicfunction';
import { cn } from '../../utils/utils';

const ErrorText = ({ text = '', className }) => {
  const { TextWeight, TextAlign } = dynamicfunction();

  if (!text) return null;

  return <p className={cn('text-red-600 text-xs mt-2', TextWeight.light, TextAlign, className)}>{text}</p>;
};

export default ErrorText;
